// src/components/ThemeSwitcher/ThemeSwitcher.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../hooks';
import './ThemeSwitcher.css';

const ThemeSwitcher = ({ className }) => {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const themes = [
    { code: 'light', label: t('settings.theme.light'), icon: Sun },
    { code: 'dark', label: t('settings.theme.dark'), icon: Moon },
  ];

  return (
    <div className={`settings-section ${className || ''}`}>
      {themes.map((themeOption) => {
        const Icon = themeOption.icon;
        return (
          <button
            key={themeOption.code}
            onClick={() => setTheme(themeOption.code)}
            className={`settings-button ${theme === themeOption.code ? 'active' : ''}`}
            aria-label={`${t('settings.theme.switchTo')} ${themeOption.label}`}
            aria-pressed={theme === themeOption.code}
          >
            <Icon size={18} className="settings-button-icon" aria-hidden="true" />
            <span className="settings-button-content">
              {themeOption.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ThemeSwitcher;